import logo from "../assets/img/logo/HD_wit_transparant_cropped.png";

export default function Footer() {
  return (
    <>
      <div className="footer__content">
        <div className="footer__body flex">
          <div className="footer__body_item">
            <img className="footer__logo__image" src={logo} alt="demo"></img>
          </div>
          <div className="footer__body_item">
            <h5>Repetitie</h5>
            <p>
              Dinsdag 20.00u <br />
              De Pelgrimskerk <br />
              Horizonstraat 73
              <br />
              6446 SC Brunssum
            </p>
          </div>
          <div className="footer__body_item">
            <h5>Contact</h5>
            <a href="mailto:secretariaat@harpedavidsbrunssum.net">
              <p>Sandra Postuma (secretariaat)</p>
            </a>
            <a href="mailto:voorzitter@harpedavidsbrunssum.net">
              <p>Maurits van der Werff (voorzitter)</p>
            </a>
            <a href="mailto:penningmeester@harpedavidsbrunssum.net">
              <p>penningmeester</p>
            </a>
          </div>
          <div className="footer__body_item">
            <h5>Links</h5>
            <a href="https://www.facebook.com/Harpedavidsbrunssum/">
              <p>Facebook</p>
            </a>
            <a href="https://www.instagram.com/harpedavidsbrunssum/">
              <p>Instagram</p>
            </a>
            <a href="https://www.facebook.com/voorzitter.harpedavids.7">
              <p>Facebook Voorzitter</p>
            </a>
            {/* <a href="https://lokaaltotaal.nl/brunssum/organisaties-en-verenigingen/m/muziekverenigingen/fanfare-harpe-davids">
              <p>Gemeentegids</p>
            </a> */}
          </div>
        </div>
      </div>
    </>
  );
}
